import styled from 'styled-components';
import { Icon } from '@web-chat-core/ui-kit';

export const Wrapper = styled.label`
    display: flex;
    align-items: flex-start;
    position: relative;
`;

export const CheckboxIcon = styled(Icon)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const CheckboxIconWrapper = styled.div<{
    checked?: boolean;
    disabled?: boolean;
}>`
    display: inline-block;
    cursor: pointer;
    width: 20px;
    min-width: 20px;
    height: 20px;
    margin-right: 14px;
    position: relative;
    border-radius: 6px;

    ${props => {
        if (props.checked) {
            return `
                opacity: ${props.disabled ? 0.3 : 1};
            `;
        }

        return `
            background: transparent;
                svg {
                    fill: ${
                        props.disabled
                            ? props.theme.root.colors.basicColors['80%']
                            : props.theme.root.colors.basicColors['55%']
                    };
                }
            `;
    }}
`;

export const Input = styled.input`
    position: absolute;
    z-index: -1;
    visibility: hidden;
`;
